'use client';

import { ReactNode, useLayoutEffect, useState } from 'react';

import { useMediaQuery } from 'react-responsive';

import breakPoint from '@utils/theme/breakPoint';

import { createGenericContext } from '../generateContext';

const xsQueryWidth = parseInt(breakPoint?.TABLET?.split('px')?.[0], 10) ?? 0;

const [useBreakpoint, DeviceContextProvider] = createGenericContext<{
  xl: boolean;
  xs: boolean;
  md: boolean;
}>();

const useBreakpoints = () => {
  const xxl = useMediaQuery({
    query: `(min-width: ${breakPoint.LARGE_2X})`,
  });
  const xl = useMediaQuery({
    query: `(min-width: ${breakPoint.LARGE_1X})`,
  });
  const lg = useMediaQuery({
    query: `(min-width: ${breakPoint.WIDE_DESKTOP})`,
  });
  const md = useMediaQuery({
    query: `(min-width: ${breakPoint.DESKTOP})`,
  });
  const sm = useMediaQuery({
    query: `(min-width: ${breakPoint.TABLET})`,
  });

  const xs = useMediaQuery({
    query: `(max-width: ${xsQueryWidth - 1}px)`,
  });

  return { xxl, xl, lg, md, sm, xs };
};

const DeviceProvider = ({
  params: { xl, xs, md },
  children,
}: {
  params: { xl: boolean; xs: boolean; md: boolean };
  children: ReactNode;
}): React.JSX.Element => {
  const breakpoints = useBreakpoints();
  const [current, setCurrent] = useState({ xl, xs, md });

  useLayoutEffect(() => {
    setCurrent({
      xl: breakpoints.xl,
      xs: breakpoints.xs,
      md: breakpoints.md,
    });
  }, [breakpoints.xl, breakpoints.xs, breakpoints.md]);

  return (
    <DeviceContextProvider value={current}>{children}</DeviceContextProvider>
  );
};

export { useBreakpoint, DeviceProvider };
